export default __webpack_public_path__ + "static/media/step-4-inactive.ccf4c40c.svg";